var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5556 16.4622C19.9389 17.05 20.7778 17.8211 20.7778 18.6667C20.7778 20.5078 16.7978 22 11.8889 22C6.98 22 3 20.5078 3 18.6667C3 17.8222 3.83889 17.0489 5.22222 16.4622",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4445 8.04889C17.4445 11.4856 11.8889 17.5556 11.8889 17.5556C11.8889 17.5556 6.33337 11.4856 6.33337 8.04889C6.33337 4.61334 8.82115 2 11.8889 2C14.9567 2 17.4445 4.61334 17.4445 8.04889V8.04889Z",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 8.66668C12.5026 8.66668 13.0001 8.16922 13.0001 7.55557C13.0001 6.94192 12.5026 6.44446 11.8889 6.44446C11.2753 6.44446 10.7778 6.94192 10.7778 7.55557C10.7778 8.16922 11.2753 8.66668 11.8889 8.66668Z",
    fill: "white",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e9167d4ae2c6a1ddcaff12af47d6e171.svg";
export { ForwardRef as ReactComponent };